import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './adverse-outcome-pathway.reducer';

export const AdverseOutcomePathwayDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const adverseOutcomePathwayEntity = useAppSelector(state => state.adverseOutcomePathway.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="adverseOutcomePathwayDetailsHeading">
          <Translate contentKey="coconApp.adverseOutcomePathway.detail.title">AdverseOutcomePathway</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{adverseOutcomePathwayEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.adverseOutcomePathway.name">Name</Translate>
            </span>
          </dt>
          <dd>{adverseOutcomePathwayEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/adverse-outcome-pathway" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/adverse-outcome-pathway/${adverseOutcomePathwayEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AdverseOutcomePathwayDetail;
